
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAKn-KVhSZ6NozaAQCwZ05AWaMA61LVrrM",
    /*
     * Tên miền riêng, KHÔNG để mặc định "sportbook-401008.firebaseapp.com".
     *
     * Hai lý do:
     *
     *  - Màn chọn tài khoản của Google ghi "to continue to <authDomain>". Để
     *    mặc định thì người dùng đọc được "sportbook-401008.firebaseapp.com" -
     *    một chuỗi không ai nhận ra là Biadi, và đó chính là chỗ người ta chần
     *    chừ không bấm tiếp. (Muốn hiện hẳn chữ "Biadi" thì phải qua bước Google
     *    duyệt thương hiệu, lâu hơn nhiều.)
     *  - Quan trọng hơn về lâu dài: app chạy ở *.biadi.vn mà trang xử lý đăng
     *    nhập nằm ở firebaseapp.com thì với trình duyệt đó là bên thứ ba.
     *    Safari và Chrome đang siết dần cookie/storage bên thứ ba, và đó là
     *    nguyên nhân phổ biến làm đăng nhập Google tự dưng hỏng. Cùng
     *    biadi.vn thì không dính.
     *
     * Tên miền này là một site Firebase Hosting (CNAME trỏ sang
     * sportbook-401008.web.app) chỉ để phục vụ /__/auth/handler; front office
     * vẫn chạy trên máy chủ riêng như cũ. Đổi dòng này mà tên miền chưa sống là
     * nút đăng nhập Google hỏng ngay, nên nó phải đi SAU ba việc trong console:
     * Hosting custom domain, Authorized domains, và Authorized redirect URI của
     * OAuth client (https://auth.biadi.vn/__/auth/handler).
     */
    authDomain: "auth.biadi.vn",
    databaseURL: "https://sportbook-401008-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "sportbook-401008",
    storageBucket: "sportbook-401008.appspot.com",
    messagingSenderId: "749436763004",
    appId: "1:749436763004:web:7aca5194b8acc3f8e142f9"
};

const firebaseApp = initializeApp(firebaseConfig);
const realtimeDB = getDatabase(firebaseApp);

/* Thông báo đẩy cần chính đối tượng app, không phải realtime database. Xuất
   riêng chứ không đổi default export: đã có 5 chỗ import mặc định là database. */
export { firebaseApp };

// Tham chiếu tới cơ sở dữ liệu

export default realtimeDB;